import React from 'react'
import { Helmet } from 'react-helmet-async'
import { withRouter } from 'src/lib/router/with_router'
import { connect } from 'react-redux'
import { Card } from 'react-bootstrap'

import { toggleShowForgotPassword } from 'src/store/login'
import LoginVariant from 'src/components/system_wide/login_form/login_variant'
import VerifyEmailVariant from 'src/components/system_wide/login_form/verify_email_variant'
import ForgotPasswordVariant from 'src/components/system_wide/login_form/forgot_password_variant'
import UpdatePasswordVariant from 'src/components/system_wide/login_form/update_password_variant'
import { resetLoginData } from 'src/store/login'

const mstp = state => {
  return { loginData: state.loginData, userInfo: state.userInfo }
}

class Login extends React.Component {
  static defaultProps = {
    redirectUrl: '/',
    maintenanceMode: false,
  }

  handleForgotPassword = e => {
    e.preventDefault()
    this.props.dispatch(toggleShowForgotPassword())
  }

  componentDidUpdate() {
    let { show_verify_email, show_update_password } = this.props.loginData
    let hasRequiredActions = show_verify_email || show_update_password
    if (!hasRequiredActions) {
      if (this.props.router.location.pathname !== this.props.redirectUrl && this.props.userInfo.username) {
        return this.props.router.navigate(this.props.redirectUrl, { replace: true })
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetLoginData())
  }

  render() {
    let { loginData, maintenanceMode } = this.props
    let { show_verify_email, show_update_password, show_forgot_password } = loginData
    let variant = ''
    let icon = 'feather icon-unlock auth-icon'
    switch (true) {
      case show_verify_email === true:
        variant = 'showVerifyEmail'
        break
      case show_update_password === false && show_forgot_password === false:
        variant = 'showLogin'
        break
      case show_update_password === false && show_forgot_password === true:
        variant = 'showForgotPwd'
        break
      case show_update_password === true && show_forgot_password === false:
        variant = 'showUpdatePwd'
        icon = 'fa fa-key'
        break
      default:
        break
    }

    return (
      <>
        <Helmet>
          <title>Risiko idea</title>
        </Helmet>
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <Card className="borderless">
              <Card.Body>
                <div className="mb-2 text-center">
                  <i className={`${icon}`} />
                </div>
                {variant === 'showLogin' && (
                  <LoginVariant
                    loginData={this.props.loginData}
                    dispatch={this.props.dispatch}
                    handleForgotPassword={this.handleForgotPassword}
                    maintenanceMode={maintenanceMode}
                  />
                )}
                {variant === 'showVerifyEmail' && (
                  <VerifyEmailVariant loginData={this.props.loginData} dispatch={this.props.dispatch} />
                )}

                {variant === 'showForgotPwd' && (
                  <ForgotPasswordVariant
                    loginData={this.props.loginData}
                    dispatch={this.props.dispatch}
                    handleForgotPassword={this.handleForgotPassword}
                  />
                )}
                {variant === 'showUpdatePwd' && (
                  <UpdatePasswordVariant
                    title="Update password"
                    loginData={this.props.loginData}
                    dispatch={this.props.dispatch}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </>
    )
  }
}

export default connect(mstp)(withRouter(Login))
